<template>
    <div>
        <el-popover placement="right-start" ref="popover" title="选择实体" :width="500" trigger="click">
            <template #reference>
                <div class="button-icon icon-shop button-icon-checked">实体</div>
            </template>
            <div style="height: 400px; overflow: auto">
                <div style="padding: 10px">
                    <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                </div>
                <el-tree
                    class="my-tree"
                    ref="tree"
                    style="margin-top: 5px"
                    :data="dataList"
                    node-key="EntityID"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    @node-click="handleNodeClick"
                >
                    <template #default="{ data }">
                        <div class="custom-tree-node">
                            <span class="menu-icon icon-org" v-if="data.EntityType == 101"></span>
                            <span class="menu-icon icon-shop" v-if="data.EntityType == 1"></span>
                            <span class="menu-icon icon-floor" v-if="data.EntityType == 2"></span>
                            <span class="menu-icon icon-market" v-if="data.EntityType == 3"></span>
                            <span>{{ data.EntityName }}</span>
                        </div>
                    </template>
                </el-tree>
            </div>
        </el-popover>
    </div>
</template>

<script>
import auth from "../scripts/auth";
export default {
    name: "SelectEntityIcon",
    props: {
        entity: { type: Object },
    },
    data() {
        return {
            dataList: [],
            nodeName: "",
            filterText: "",
            selectedEntity: null,
        };
    },
    created() {},
    mounted() {
        if (this.entity) {
            this.setSelectEntity(this.entity);
        } else {
            let data = auth.getTokenData();
            if (data && data.Entity) {
                this.setSelectEntity(data.Entity);
            }
        }
        this.getOrgEntityTree();
    },
    methods: {
        setSelectEntity(e) {
            this.selectedEntity = e;
            this.nodeName = this.selectedEntity.EntityName;
            this.$emit("select", this.selectedEntity);
        },
        getOrgEntityTree() {
            this.$ajax.post("/Entity/GetEntityTree").then((res) => {
                if (res.Data) {
                    this.dataList = res.Data;
                    if (!this.selectedEntity && this.dataList.length > 0) {
                        this.setSelectEntity(this.dataList[0]);
                    }
                } else {
                    this.dataList = [];
                }
            });
        },
        filterNode(value, data) {
            if (!value) return true;
            console.log(data);
            return data.EntityName.includes(value);
        },
        handleNodeClick(data) {
            this.$refs.popover.hide();
            this.setSelectEntity(data);
        },
    },
};
</script>

<style scoped>
.custom-tree-node .menu-icon {
    width: 20px;
    font-size: 18px;
    position: relative;
}
</style>
